"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.tsx
var src_exports = {};
__export(src_exports, {
  BACKOFFICE_PLEDGE_SECTION_STATUSES_ICON: () => BACKOFFICE_PLEDGE_SECTION_STATUSES_ICON,
  BACKOFFICE_PLEDGE_STATUSES_ICON: () => BACKOFFICE_PLEDGE_STATUSES_ICON,
  Breadcrumbs: () => Breadcrumbs,
  CREDITOR_PLEDGE_STATUSES_ICON: () => CREDITOR_PLEDGE_STATUSES_ICON,
  DEBTOR_PLEDGE_STATUSES_ICON: () => DEBTOR_PLEDGE_STATUSES_ICON,
  DOTS: () => DOTS,
  PLEDGE_SECTION_STATUSES_ICON: () => PLEDGE_SECTION_STATUSES_ICON,
  PageHeader: () => PageHeader,
  Pagination: () => Pagination,
  S3FileUploader: () => S3FileUploader,
  STATUS_ICON: () => STATUS_ICON,
  accessRequestStatusBadgeColors: () => accessRequestStatusBadgeColors,
  backofficeClientDossierStatusGeneralBadgeColors: () => backofficeClientDossierStatusGeneralBadgeColors,
  backofficeCropPledgeStatusBadgeColors: () => backofficeCropPledgeStatusBadgeColors,
  backofficePledgeSectionStatusBadgeColors: () => backofficePledgeSectionStatusBadgeColors,
  backofficeStatusBadgeColors: () => backofficeStatusBadgeColors,
  clientDossierStatusGeneralBadgeColors: () => clientDossierStatusGeneralBadgeColors,
  creditorCropPledgeStatusBadgeColors: () => creditorCropPledgeStatusBadgeColors,
  creditorPledgeSectionStatusBadgeColors: () => creditorPledgeSectionStatusBadgeColors,
  debtorCropPledgeStatusBadgeColors: () => debtorCropPledgeStatusBadgeColors,
  debtorPledgeSectionStatusBadgeColors: () => debtorPledgeSectionStatusBadgeColors,
  digitalDossierStatusBadgeColors: () => digitalDossierStatusBadgeColors,
  getPledgeSectionIconAndVariant: () => getPledgeSectionIconAndVariant,
  useHandleApiError: () => useHandleApiError,
  usePagination: () => usePagination,
  usePendingChangesAlert: () => usePendingChangesAlert,
  validationStatusBadgeColors: () => validationStatusBadgeColors,
  viewerDigitalDossierGeneralStatusBadgeColors: () => viewerDigitalDossierGeneralStatusBadgeColors
});
module.exports = __toCommonJS(src_exports);

// src/components/Breadcrumbs/Breadcrumbs.tsx
var import_ui = require("@agrotoken-tech/ui");
var import_react = require("react");
var import_react_hooks = require("@bcba/react-hooks");
var import_jsx_runtime = require("react/jsx-runtime");
var Breadcrumbs = ({
  paths,
  currentPath,
  onNavigate,
  translationPrefix,
  pageTitle
}) => {
  const { t } = (0, import_react_hooks.useTranslation)();
  const [breadcrumbs, setBreadcrumbs] = (0, import_react.useState)([]);
  (0, import_react.useEffect)(() => {
    if (pageTitle) {
      const pathnames = currentPath.split("/").filter((x) => x);
      const breadcrumbList = pathnames.map((value, index) => {
        const path = `/${pathnames.slice(0, index + 1).join("/")}`;
        const routeKey = Object.keys(paths).find((key) => {
          const routePath = typeof paths[key] === "string" ? paths[key] : "";
          return routePath.split("/:")[0] === path;
        });
        return {
          to: path,
          label: routeKey ? t(`${translationPrefix}.${routeKey}`) : pageTitle
        };
      });
      setBreadcrumbs(breadcrumbList);
    }
  }, [currentPath, pageTitle, paths, t, translationPrefix]);
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_ui.Box, { flex: "1", mb: 4, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_ui.Breadcrumb,
    {
      showHomeOnFirstItem: false,
      options: breadcrumbs,
      onNavigate
    }
  ) });
};

// src/components/PageHeader.tsx
var import_ui2 = require("@agrotoken-tech/ui");
var import_jsx_runtime2 = require("react/jsx-runtime");
var PageHeader = ({ title, description, actions, badge }) => {
  const displayMobile = { base: "flex", md: "none" };
  const displayDesktop = { base: "none", md: "flex" };
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(import_ui2.Flex, { direction: "column", gap: 4, children: [
    /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(import_ui2.Flex, { direction: "column", gap: 1, children: [
      /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_ui2.Box, { display: displayMobile, children: badge }),
      /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(
        import_ui2.Flex,
        {
          justifyContent: "space-between",
          alignItems: { base: "normal", md: "center" },
          direction: { base: "column", md: "row" },
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime2.jsxs)(import_ui2.Flex, { alignItems: "center", gap: 4, children: [
              /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_ui2.Heading, { size: "md", children: title }),
              /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_ui2.Box, { display: displayDesktop, children: badge })
            ] }),
            actions && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_ui2.Box, { display: displayDesktop, children: actions })
          ]
        }
      ),
      description && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_ui2.Text, { whiteSpace: "break-spaces", children: description })
    ] }),
    actions && /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(import_ui2.Box, { display: displayMobile, children: actions })
  ] });
};

// ../../node_modules/react-icons/lib/esm/iconBase.js
var import_react3 = __toESM(require("react"));

// ../../node_modules/react-icons/lib/esm/iconContext.js
var import_react2 = __toESM(require("react"));
var DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
var IconContext = import_react2.default.createContext && import_react2.default.createContext(DefaultContext);

// ../../node_modules/react-icons/lib/esm/iconBase.js
var __assign = function() {
  __assign = Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = function(s, e) {
  var t = {};
  for (var p in s)
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
};
function Tree2Element(tree) {
  return tree && tree.map(function(node, i) {
    return import_react3.default.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  return function(props) {
    return import_react3.default.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function(conf) {
    var attr = props.attr, size = props.size, title = props.title, svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className)
      className = conf.className;
    if (props.className)
      className = (className ? className + " " : "") + props.className;
    return import_react3.default.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && import_react3.default.createElement("title", null, title), props.children);
  };
  return IconContext !== void 0 ? import_react3.default.createElement(IconContext.Consumer, null, function(conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}

// ../../node_modules/react-icons/fi/index.esm.js
function FiArrowLeft(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "line", "attr": { "x1": "19", "y1": "12", "x2": "5", "y2": "12" } }, { "tag": "polyline", "attr": { "points": "12 19 5 12 12 5" } }] })(props);
}
function FiArrowRight(props) {
  return GenIcon({ "tag": "svg", "attr": { "viewBox": "0 0 24 24", "fill": "none", "stroke": "currentColor", "strokeWidth": "2", "strokeLinecap": "round", "strokeLinejoin": "round" }, "child": [{ "tag": "line", "attr": { "x1": "5", "y1": "12", "x2": "19", "y2": "12" } }, { "tag": "polyline", "attr": { "points": "12 5 19 12 12 19" } }] })(props);
}

// src/components/Pagination/usePagination.ts
var import_react4 = require("react");
var DOTS = "...";
var range = (start, end) => {
  const length = end - start + 1;
  return Array.from({ length }, (_, idx) => idx + start);
};
var usePagination = ({
  totalPageCount,
  currentPage
}) => {
  const siblingCount = 1;
  const paginationRange = (0, import_react4.useMemo)(() => {
    const totalPageNumbers = siblingCount + 5;
    if (totalPageNumbers >= totalPageCount) {
      return range(1, totalPageCount);
    }
    const leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    const rightSiblingIndex = Math.min(
      currentPage + siblingCount,
      totalPageCount
    );
    const shouldShowLeftDots = leftSiblingIndex > 2;
    const shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;
    const firstPageIndex = 1;
    const lastPageIndex = totalPageCount;
    if (!shouldShowLeftDots && shouldShowRightDots) {
      const leftItemCount = 3 + 2 * siblingCount;
      const leftRange = range(1, leftItemCount);
      return [...leftRange, DOTS, totalPageCount];
    }
    if (shouldShowLeftDots && !shouldShowRightDots) {
      const rightItemCount = 3 + 2 * siblingCount;
      const rightRange = range(
        totalPageCount - rightItemCount + 1,
        totalPageCount
      );
      return [firstPageIndex, DOTS, ...rightRange];
    }
    if (shouldShowLeftDots && shouldShowRightDots) {
      const middleRange = range(leftSiblingIndex, rightSiblingIndex);
      return [firstPageIndex, DOTS, ...middleRange, DOTS, lastPageIndex];
    }
  }, [totalPageCount, siblingCount, currentPage]);
  return paginationRange;
};

// src/components/Pagination/Pagination.tsx
var import_ui3 = require("@agrotoken-tech/ui");
var import_jsx_runtime3 = require("react/jsx-runtime");
var Pagination = (props) => {
  const {
    onPageChange,
    totalPageCount,
    currentPage,
    previousButtonLabel,
    nextButtonLabel,
    theme
  } = props;
  const paginationRange = usePagination({
    currentPage,
    totalPageCount
  });
  if (currentPage === 0 || (paginationRange == null ? void 0 : paginationRange.length) && paginationRange.length < 2) {
    return null;
  }
  const onNext = () => {
    onPageChange(currentPage + 1);
  };
  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };
  let lastPage = paginationRange ? paginationRange[paginationRange.length - 1] : 0;
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_ui3.ThemeProvider, __spreadProps(__spreadValues({}, theme ? theme : {}), { children: /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(import_ui3.Flex, { width: "100%", justifyContent: "space-between", children: [
    /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
      import_ui3.Button,
      {
        variant: "link",
        leftIcon: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FiArrowLeft, {}),
        onClick: onPrevious,
        isDisabled: currentPage === 1,
        children: previousButtonLabel
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_ui3.Flex, { children: paginationRange == null ? void 0 : paginationRange.map((pageNumber) => {
      if (pageNumber === DOTS) {
        return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
          import_ui3.Flex,
          {
            width: "8",
            height: "8",
            justifyContent: "center",
            alignItems: "center",
            children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(import_ui3.Text, { color: "gray.500", children: "..." })
          },
          pageNumber
        );
      }
      return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
        import_ui3.Text,
        {
          size: "sm",
          _hover: {
            textColor: "gray.900",
            backgroundColor: currentPage === pageNumber ? "gray.100" : "gray.50"
          },
          backgroundColor: currentPage === pageNumber ? "gray.100" : "white",
          borderRadius: "8px",
          onClick: () => onPageChange(pageNumber),
          width: "8",
          height: "8",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          color: currentPage === pageNumber ? "gray.900" : "gray.500",
          as: import_ui3.Flex,
          children: pageNumber
        },
        pageNumber
      );
    }) }),
    /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
      import_ui3.Button,
      {
        variant: "link",
        rightIcon: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FiArrowRight, {}),
        onClick: onNext,
        isDisabled: currentPage === lastPage || totalPageCount === 0,
        children: nextButtonLabel
      }
    )
  ] }) }));
};

// src/components/S3FileUploader/S3FileUploader.tsx
var import_ui4 = require("@agrotoken-tech/ui");
var import_client_auth = require("@bcba/client-auth");
var import_common_utils = require("@bcba/common-utils");
var import_react_hooks2 = require("@bcba/react-hooks");
var import_types2 = require("@bcba/types");
var import_react5 = require("react");

// src/components/S3FileUploader/utils.ts
var import_types = require("@bcba/types");
var fileExtensionToMimeType = (fileExtension) => {
  switch (fileExtension) {
    case "pdf":
      return import_types.FILE_MIME_TYPES.PDF;
    case "png":
      return import_types.FILE_MIME_TYPES.PNG;
    case "jpeg":
    case "jpg":
      return import_types.FILE_MIME_TYPES.JPEG;
    case "kmz":
      return import_types.FILE_MIME_TYPES.KMZ;
    case "geojson":
    case "json":
      return import_types.FILE_MIME_TYPES.GEOJSON;
    default:
      throw new Error("Not implemented");
  }
};
var getFileExtension = (fileName) => {
  var _a, _b;
  return (_b = (_a = fileName.match(/[^.]+\.([^.]+)$/)) == null ? void 0 : _a[1]) != null ? _b : "";
};

// src/components/S3FileUploader/S3FileUploader.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
var S3FileUploader = ({
  messages,
  required,
  label,
  fieldPrefix,
  getS3PreSignedUrl,
  mimeTypes = import_types2.defaultMimeTypes,
  onFileUploadSuccess,
  onDeleteClick,
  helperText
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const { t } = (0, import_react_hooks2.useTranslation)();
  const [isLoadingUpload, setIsLoadingUpload] = (0, import_react5.useState)(false);
  const [errorUploadingFile, setErrorUploadingFile] = (0, import_react5.useState)();
  const [files, setFiles] = (0, import_react5.useState)([]);
  (0, import_react5.useEffect)(() => {
    const file = files == null ? void 0 : files[0];
    if (file) {
      setIsLoadingUpload(true);
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = () => {
        if (reader.result) {
          const binaryData = reader.result;
          const fileName = file.name;
          const sanitizedFilename = (0, import_common_utils.sanitizeFilename)(fileName);
          getS3PreSignedUrl(sanitizedFilename).then((data) => __async(void 0, null, function* () {
            const { s3Key, url, sanitizedFilename: sanitizedFilename2 } = data;
            yield import_client_auth.s3HttpClient.put(url, binaryData).then(() => {
              const fileMimeType = file.type || fileExtensionToMimeType(getFileExtension(file.name));
              onFileUploadSuccess(sanitizedFilename2, fileMimeType, s3Key);
            }).catch((error) => {
              setFiles([]);
              setErrorUploadingFile(error);
            }).finally(() => setIsLoadingUpload(false));
          }));
        }
      };
      reader.onerror = () => {
        console.error("Failed to read file!");
      };
    }
  }, [files]);
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)(import_ui4.Flex, { direction: "column", children: [
    /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
      import_ui4.DropzoneField,
      __spreadProps(__spreadValues({
        helperText,
        errorMessageFormatter: t,
        rhfOptions: { required },
        name: fieldPrefix,
        label
      }, { minWidth: "unset" }), {
        clickHereMessage: (_a = messages == null ? void 0 : messages.clickHere) != null ? _a : t("common.uploadFile.clickHereMessage"),
        orDropTheFileMessage: (_b = messages == null ? void 0 : messages.orDropTheFile) != null ? _b : t("common.uploadFile.orDropTheFileMessage"),
        tryAgainMessage: (_c = messages == null ? void 0 : messages.tryAgain) != null ? _c : t("common.uploadFile.tryAgainMessage"),
        fileInvalidTypeMessage: (_d = messages == null ? void 0 : messages.fileInvalidType) != null ? _d : t("common.uploadFile.fileInvalidTypeMessage"),
        fileTooLargeMessage: (_e = messages == null ? void 0 : messages.fileTooLarge) != null ? _e : t("common.uploadFile.fileTooLargeMessage"),
        fileTooSmallMessage: (_f = messages == null ? void 0 : messages.fileTooSmall) != null ? _f : t("common.uploadFile.fileTooSmallMessage"),
        tooManyFilesMessage: (_g = messages == null ? void 0 : messages.tooManyFiles) != null ? _g : t("common.uploadFile.tooManyFilesMessage"),
        supportedFileTypes: messages == null ? void 0 : messages.supportedFileTypes,
        accept: mimeTypes,
        setValueAsBase64: true,
        isLoading: isLoadingUpload,
        files,
        setFiles,
        onDeleteClick
      })
    ),
    errorUploadingFile && /* @__PURE__ */ (0, import_jsx_runtime4.jsxs)(import_ui4.Flex, { gap: 2, my: 1, children: [
      /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_ui4.FiAlertCircle, { size: 16, color: "#c72100" }),
      /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(import_ui4.Text, { color: "content-destructive", size: "sm", variant: "regular", children: (_h = messages == null ? void 0 : messages.uploadError) != null ? _h : t("common.uploadFile.uploadError") })
    ] })
  ] });
};

// src/hooks/useHandleApiError.ts
var import_react_hooks3 = require("@bcba/react-hooks");
var useHandleApiError = () => {
  const { showErrorToast } = (0, import_react_hooks3.useToastsHook)();
  const { t } = (0, import_react_hooks3.useTranslation)();
  const handleApiError = (error) => {
    const axiosError = error;
    if (axiosError == null ? void 0 : axiosError.code) {
      const errorMessage = t(
        `toast.error.${axiosError == null ? void 0 : axiosError.code}.title`,
        {
          defaultValue: t("common.toast.error.title")
        }
      );
      const errorDescription = t(
        `toast.error.${axiosError == null ? void 0 : axiosError.code}.text`,
        {
          defaultValue: t("common.toast.error.text")
        }
      );
      showErrorToast({ title: errorMessage, text: errorDescription });
    }
  };
  return { handleApiError };
};

// src/hooks/usePendingChangesAlert.tsx
var import_react6 = require("react");
var import_ui5 = require("@agrotoken-tech/ui");
var usePendingChangesAlert = (hasUserPendingChanges, setUserHasPendingChanges) => {
  const {
    isOpen: isPendingChangeAlertOpen,
    onOpen: onPendingChangeAlertOpen,
    onClose: onPendingChangeAlertClose
  } = (0, import_ui5.useDisclosure)();
  const cancelPendingChangeAlertModal = () => {
    onPendingChangeAlertClose();
  };
  const confirmPendingChangeAlertModal = () => {
    setUserHasPendingChanges(false);
    onPendingChangeAlertClose();
  };
  (0, import_react6.useEffect)(() => {
    setUserHasPendingChanges(hasUserPendingChanges);
    return () => {
      setUserHasPendingChanges(false);
    };
  }, [hasUserPendingChanges, setUserHasPendingChanges]);
  return {
    isPendingChangeAlertOpen,
    confirmPendingChangeAlertModal,
    cancelPendingChangeAlertModal,
    onPendingChangeAlertOpen
  };
};

// src/utils/access-requests-status.utils.ts
var import_types3 = require("@bcba/types");
var accessRequestStatusBadgeColors = {
  [import_types3.DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS.PENDING]: "gray",
  [import_types3.DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS.APPROVED]: "success",
  [import_types3.DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS.EXPIRED]: "warning",
  [import_types3.DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS.REJECTED]: "error",
  [import_types3.DIGITAL_DOSSIER_ACCESS_REQUEST_STATUS.REVOKED]: "error"
};

// src/utils/digital-dossiers.utils.ts
var import_types4 = require("@bcba/types");
var digitalDossierStatusBadgeColors = {
  [import_types4.DIGITAL_DOSSIER_STATUS.PENDING_DATA_UPLOAD_CLIENT]: "gray",
  [import_types4.DIGITAL_DOSSIER_STATUS.PENDING_DATA_UPLOAD_BACKOFFICE]: "warning",
  [import_types4.DIGITAL_DOSSIER_STATUS.PENDING_APPROVAL]: "warning",
  [import_types4.DIGITAL_DOSSIER_STATUS.APPROVED]: "success"
};
var clientDossierStatusGeneralBadgeColors = {
  [import_types4.CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS.INFORMATION_EXPIRED]: "error",
  [import_types4.CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS.RUCA_EXPIRED]: "error",
  [import_types4.CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS.APPROVED]: "success"
};
var backofficeClientDossierStatusGeneralBadgeColors = __spreadProps(__spreadValues({}, digitalDossierStatusBadgeColors), {
  [import_types4.CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS.INFORMATION_EXPIRED]: "error",
  [import_types4.CLIENT_DIGITAL_DOSSIER_GENERAL_STATUS.RUCA_EXPIRED]: "error"
});

// src/utils/validation-status.utils.ts
var import_types5 = require("@bcba/types");
var validationStatusBadgeColors = {
  [import_types5.VALIDATION_STATUSES.INCOMPLETE]: "warning",
  [import_types5.VALIDATION_STATUSES.PENDING_APPROVAL]: "gray",
  [import_types5.VALIDATION_STATUSES.PENDING_CHANGE_REQUEST]: "error",
  [import_types5.VALIDATION_STATUSES.REJECTED]: "error",
  [import_types5.VALIDATION_STATUSES.APPROVED]: "success"
};
var backofficeStatusBadgeColors = {
  [import_types5.DIGITAL_DOSSIER_STATUS.PENDING_APPROVAL]: "gray",
  [import_types5.DIGITAL_DOSSIER_STATUS.PENDING_DATA_UPLOAD_BACKOFFICE]: "warning",
  [import_types5.DIGITAL_DOSSIER_STATUS.PENDING_DATA_UPLOAD_CLIENT]: "gray",
  [import_types5.DIGITAL_DOSSIER_STATUS.APPROVED]: "success"
};

// src/utils/viewer-digital-dossier-general-status.utils.ts
var import_types6 = require("@bcba/types");
var viewerDigitalDossierGeneralStatusBadgeColors = {
  [import_types6.VIEWER_DIGITAL_DOSSIER_GENERAL_STATUS.INFORMATION_EXPIRED]: "error",
  [import_types6.VIEWER_DIGITAL_DOSSIER_GENERAL_STATUS.RUCA_EXPIRED]: "error",
  [import_types6.VIEWER_DIGITAL_DOSSIER_GENERAL_STATUS.APPROVED]: "success"
};

// src/utils/status-icon.utils.ts
var import_ui6 = require("@agrotoken-tech/ui");
var import_types7 = require("@bcba/types");
var STATUS_ICON = {
  [import_types7.VALIDATION_STATUSES.PENDING_APPROVAL]: import_ui6.PendingClockIcon,
  [import_types7.VALIDATION_STATUSES.INCOMPLETE]: import_ui6.FiAlertTriangle,
  [import_types7.VALIDATION_STATUSES.PENDING_CHANGE_REQUEST]: import_ui6.FiAlertCircle,
  [import_types7.VALIDATION_STATUSES.REJECTED]: import_ui6.FiAlertCircle,
  [import_types7.VALIDATION_STATUSES.APPROVED]: import_ui6.FiCheckCircle
};

// src/utils/crop-pledge.util.ts
var import_ui7 = require("@agrotoken-tech/ui");
var import_types8 = require("@bcba/types");
var debtorCropPledgeStatusBadgeColors = {
  [import_types8.PLEDGE_STATUSES.PENDING_DEBTOR_LOAD]: "warning",
  [import_types8.PLEDGE_STATUSES.PENDING_BOLSA_LOAD]: "gray",
  [import_types8.PLEDGE_STATUSES.PENDING_BOLSA_FARM_LOAD]: "gray",
  [import_types8.PLEDGE_STATUSES.PENDING_CREDITOR_LOAD]: "gray",
  [import_types8.PLEDGE_STATUSES.PENDING_DEBTOR_DOCUMENTATION_LOAD]: "warning",
  [import_types8.PLEDGE_STATUSES.PENDING_BOLSA_APPROVAL]: "gray",
  [import_types8.PLEDGE_STATUSES.PENDING_CREDITOR_APPROVAL]: "gray",
  [import_types8.PLEDGE_STATUSES.PENDING_REGISTRATION]: "gray",
  [import_types8.PLEDGE_STATUSES.PENDING_REGISTRATION_BLOCKCHAIN]: "gray",
  [import_types8.PLEDGE_STATUSES.REJECTED]: "error",
  [import_types8.PLEDGE_STATUSES.REGISTERED]: "success",
  [import_types8.PLEDGE_STATUSES.PENDING_RELEASE]: "gray",
  [import_types8.PLEDGE_STATUSES.RELEASED]: "error"
};
var DEBTOR_PLEDGE_STATUSES_ICON = {
  [import_types8.PLEDGE_STATUSES.PENDING_DEBTOR_LOAD]: import_ui7.FiAlertTriangle,
  [import_types8.PLEDGE_STATUSES.PENDING_BOLSA_LOAD]: import_ui7.ClockUsedIcon,
  [import_types8.PLEDGE_STATUSES.PENDING_BOLSA_FARM_LOAD]: import_ui7.ClockUsedIcon,
  [import_types8.PLEDGE_STATUSES.PENDING_CREDITOR_LOAD]: import_ui7.ClockUsedIcon,
  [import_types8.PLEDGE_STATUSES.PENDING_DEBTOR_DOCUMENTATION_LOAD]: import_ui7.FiAlertTriangle,
  [import_types8.PLEDGE_STATUSES.PENDING_BOLSA_APPROVAL]: import_ui7.ClockUsedIcon,
  [import_types8.PLEDGE_STATUSES.PENDING_CREDITOR_APPROVAL]: import_ui7.ClockUsedIcon,
  [import_types8.PLEDGE_STATUSES.PENDING_REGISTRATION]: import_ui7.PendingClockIcon,
  // clock
  [import_types8.PLEDGE_STATUSES.PENDING_REGISTRATION_BLOCKCHAIN]: import_ui7.PendingClockIcon,
  [import_types8.PLEDGE_STATUSES.REJECTED]: import_ui7.FiAlertCircle,
  // alert-octagon
  [import_types8.PLEDGE_STATUSES.REGISTERED]: import_ui7.FiCheckCircle,
  [import_types8.PLEDGE_STATUSES.PENDING_RELEASE]: import_ui7.PendingClockIcon,
  // clock
  [import_types8.PLEDGE_STATUSES.RELEASED]: import_ui7.ClockUsedIcon
  // clock-expired
};
var creditorCropPledgeStatusBadgeColors = {
  [import_types8.PLEDGE_STATUSES.PENDING_DEBTOR_LOAD]: "gray",
  [import_types8.PLEDGE_STATUSES.PENDING_BOLSA_LOAD]: "gray",
  [import_types8.PLEDGE_STATUSES.PENDING_BOLSA_FARM_LOAD]: "gray",
  [import_types8.PLEDGE_STATUSES.PENDING_CREDITOR_LOAD]: "warning",
  [import_types8.PLEDGE_STATUSES.PENDING_DEBTOR_DOCUMENTATION_LOAD]: "gray",
  [import_types8.PLEDGE_STATUSES.PENDING_BOLSA_APPROVAL]: "gray",
  [import_types8.PLEDGE_STATUSES.PENDING_CREDITOR_APPROVAL]: "warning",
  [import_types8.PLEDGE_STATUSES.PENDING_REGISTRATION]: "gray",
  [import_types8.PLEDGE_STATUSES.PENDING_REGISTRATION_BLOCKCHAIN]: "gray",
  [import_types8.PLEDGE_STATUSES.REJECTED]: "error",
  [import_types8.PLEDGE_STATUSES.REGISTERED]: "success",
  [import_types8.PLEDGE_STATUSES.PENDING_RELEASE]: "gray",
  [import_types8.PLEDGE_STATUSES.RELEASED]: "error"
};
var CREDITOR_PLEDGE_STATUSES_ICON = {
  [import_types8.PLEDGE_STATUSES.PENDING_DEBTOR_LOAD]: import_ui7.ClockUsedIcon,
  [import_types8.PLEDGE_STATUSES.PENDING_BOLSA_LOAD]: import_ui7.ClockUsedIcon,
  [import_types8.PLEDGE_STATUSES.PENDING_BOLSA_FARM_LOAD]: import_ui7.ClockUsedIcon,
  [import_types8.PLEDGE_STATUSES.PENDING_CREDITOR_LOAD]: import_ui7.FiAlertTriangle,
  [import_types8.PLEDGE_STATUSES.PENDING_DEBTOR_DOCUMENTATION_LOAD]: import_ui7.ClockUsedIcon,
  [import_types8.PLEDGE_STATUSES.PENDING_BOLSA_APPROVAL]: import_ui7.ClockUsedIcon,
  [import_types8.PLEDGE_STATUSES.PENDING_CREDITOR_APPROVAL]: import_ui7.FiAlertTriangle,
  [import_types8.PLEDGE_STATUSES.PENDING_REGISTRATION]: import_ui7.PendingClockIcon,
  // clock
  [import_types8.PLEDGE_STATUSES.PENDING_REGISTRATION_BLOCKCHAIN]: import_ui7.PendingClockIcon,
  [import_types8.PLEDGE_STATUSES.REJECTED]: import_ui7.FiAlertCircle,
  // alert-octagon
  [import_types8.PLEDGE_STATUSES.REGISTERED]: import_ui7.FiCheckCircle,
  [import_types8.PLEDGE_STATUSES.PENDING_RELEASE]: import_ui7.PendingClockIcon,
  // clock
  [import_types8.PLEDGE_STATUSES.RELEASED]: import_ui7.ClockUsedIcon
  // clock-expired
};
var backofficeCropPledgeStatusBadgeColors = {
  [import_types8.PLEDGE_STATUSES.PENDING_DEBTOR_LOAD]: "gray",
  [import_types8.PLEDGE_STATUSES.PENDING_BOLSA_LOAD]: "warning",
  [import_types8.PLEDGE_STATUSES.PENDING_BOLSA_FARM_LOAD]: "warning",
  [import_types8.PLEDGE_STATUSES.PENDING_CREDITOR_LOAD]: "gray",
  [import_types8.PLEDGE_STATUSES.PENDING_DEBTOR_DOCUMENTATION_LOAD]: "gray",
  [import_types8.PLEDGE_STATUSES.PENDING_BOLSA_APPROVAL]: "warning",
  [import_types8.PLEDGE_STATUSES.PENDING_CREDITOR_APPROVAL]: "gray",
  [import_types8.PLEDGE_STATUSES.PENDING_REGISTRATION]: "warning",
  [import_types8.PLEDGE_STATUSES.PENDING_REGISTRATION_BLOCKCHAIN]: "gray",
  [import_types8.PLEDGE_STATUSES.REJECTED]: "error",
  [import_types8.PLEDGE_STATUSES.REGISTERED]: "success",
  [import_types8.PLEDGE_STATUSES.PENDING_RELEASE]: "warning",
  [import_types8.PLEDGE_STATUSES.RELEASED]: "error"
};
var BACKOFFICE_PLEDGE_STATUSES_ICON = {
  [import_types8.PLEDGE_STATUSES.PENDING_DEBTOR_LOAD]: import_ui7.ClockUsedIcon,
  [import_types8.PLEDGE_STATUSES.PENDING_BOLSA_LOAD]: import_ui7.FiAlertTriangle,
  [import_types8.PLEDGE_STATUSES.PENDING_BOLSA_FARM_LOAD]: import_ui7.FiAlertTriangle,
  [import_types8.PLEDGE_STATUSES.PENDING_CREDITOR_LOAD]: import_ui7.ClockUsedIcon,
  [import_types8.PLEDGE_STATUSES.PENDING_DEBTOR_DOCUMENTATION_LOAD]: import_ui7.ClockUsedIcon,
  [import_types8.PLEDGE_STATUSES.PENDING_BOLSA_APPROVAL]: import_ui7.FiAlertTriangle,
  [import_types8.PLEDGE_STATUSES.PENDING_CREDITOR_APPROVAL]: import_ui7.ClockUsedIcon,
  [import_types8.PLEDGE_STATUSES.PENDING_REGISTRATION]: import_ui7.FiAlertTriangle,
  [import_types8.PLEDGE_STATUSES.PENDING_REGISTRATION_BLOCKCHAIN]: import_ui7.FiAlertTriangle,
  [import_types8.PLEDGE_STATUSES.REJECTED]: import_ui7.FiAlertCircle,
  [import_types8.PLEDGE_STATUSES.REGISTERED]: import_ui7.FiCheckCircle,
  [import_types8.PLEDGE_STATUSES.PENDING_RELEASE]: import_ui7.FiAlertTriangle,
  [import_types8.PLEDGE_STATUSES.RELEASED]: import_ui7.FiAlertCircle
};

// src/utils/crop-pledge-section.util.ts
var import_ui8 = require("@agrotoken-tech/ui");
var import_types9 = require("@bcba/types");
var debtorPledgeSectionStatusBadgeColors = {
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_DEBTOR_LOAD]: "warning",
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_BOLSA_LOAD]: "gray",
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_CREDITOR_LOAD]: "gray",
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_BOLSA_APPROVAL]: "gray",
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_CREDITOR_APPROVAL]: "gray",
  [import_types9.PLEDGE_SECTION_STATUSES.APPROVED]: "success"
};
var creditorPledgeSectionStatusBadgeColors = {
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_DEBTOR_LOAD]: "gray",
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_BOLSA_LOAD]: "gray",
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_CREDITOR_LOAD]: "warning",
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_BOLSA_APPROVAL]: "gray",
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_CREDITOR_APPROVAL]: "warning",
  [import_types9.PLEDGE_SECTION_STATUSES.APPROVED]: "success"
};
var PLEDGE_SECTION_STATUSES_ICON = {
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_DEBTOR_LOAD]: import_ui8.FiAlertTriangle,
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_BOLSA_LOAD]: import_ui8.ClockUsedIcon,
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_CREDITOR_LOAD]: import_ui8.ClockUsedIcon,
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_BOLSA_APPROVAL]: import_ui8.ClockUsedIcon,
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_CREDITOR_APPROVAL]: import_ui8.ClockUsedIcon,
  [import_types9.PLEDGE_SECTION_STATUSES.APPROVED]: import_ui8.FiCheckCircle
};
var backofficePledgeSectionStatusBadgeColors = {
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_DEBTOR_LOAD]: "gray",
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_BOLSA_LOAD]: "warning",
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_CREDITOR_LOAD]: "gray",
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_BOLSA_APPROVAL]: "warning",
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_CREDITOR_APPROVAL]: "gray",
  [import_types9.PLEDGE_SECTION_STATUSES.APPROVED]: "success"
};
var BACKOFFICE_PLEDGE_SECTION_STATUSES_ICON = {
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_DEBTOR_LOAD]: import_ui8.ClockUsedIcon,
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_BOLSA_LOAD]: import_ui8.FiAlertTriangle,
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_CREDITOR_LOAD]: import_ui8.ClockUsedIcon,
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_BOLSA_APPROVAL]: import_ui8.FiAlertTriangle,
  [import_types9.PLEDGE_SECTION_STATUSES.PENDING_CREDITOR_APPROVAL]: import_ui8.ClockUsedIcon,
  [import_types9.PLEDGE_SECTION_STATUSES.APPROVED]: import_ui8.FiCheckCircle
};
var getPledgeSectionIconAndVariant = (status, role) => {
  let iconByStatus;
  let variant;
  switch (role) {
    case import_types9.CROP_PLEDGE_USER_ROLES.DEBTOR:
      iconByStatus = PLEDGE_SECTION_STATUSES_ICON[status];
      variant = debtorPledgeSectionStatusBadgeColors[status];
      break;
    case import_types9.CROP_PLEDGE_USER_ROLES.BACKOFFICE:
      iconByStatus = BACKOFFICE_PLEDGE_SECTION_STATUSES_ICON[status];
      variant = backofficePledgeSectionStatusBadgeColors[status];
      break;
    case import_types9.CROP_PLEDGE_USER_ROLES.CREDITOR:
    default:
      iconByStatus = PLEDGE_SECTION_STATUSES_ICON[status];
      variant = creditorPledgeSectionStatusBadgeColors[status];
      break;
  }
  return { iconByStatus, variant };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  BACKOFFICE_PLEDGE_SECTION_STATUSES_ICON,
  BACKOFFICE_PLEDGE_STATUSES_ICON,
  Breadcrumbs,
  CREDITOR_PLEDGE_STATUSES_ICON,
  DEBTOR_PLEDGE_STATUSES_ICON,
  DOTS,
  PLEDGE_SECTION_STATUSES_ICON,
  PageHeader,
  Pagination,
  S3FileUploader,
  STATUS_ICON,
  accessRequestStatusBadgeColors,
  backofficeClientDossierStatusGeneralBadgeColors,
  backofficeCropPledgeStatusBadgeColors,
  backofficePledgeSectionStatusBadgeColors,
  backofficeStatusBadgeColors,
  clientDossierStatusGeneralBadgeColors,
  creditorCropPledgeStatusBadgeColors,
  creditorPledgeSectionStatusBadgeColors,
  debtorCropPledgeStatusBadgeColors,
  debtorPledgeSectionStatusBadgeColors,
  digitalDossierStatusBadgeColors,
  getPledgeSectionIconAndVariant,
  useHandleApiError,
  usePagination,
  usePendingChangesAlert,
  validationStatusBadgeColors,
  viewerDigitalDossierGeneralStatusBadgeColors
});
